import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

const CustomSelect = ({
  id,
  name,
  control,
  placeholder,
  options,
  defaultValue,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <div className="mb-3">
          <Select
            id="levels"
            styles={{
              control: (base, state) => ({
                ...base,
                border: state.isFocused
                  ? `1px solid #6ac3db`
                  : error
                  ? "1px solid #ff3333"
                  : "1px solid #C7C7C7",
                outline: state.isFocused ? "1px solid #6ac3db" : "",
                boxShadow: "none",
                padding: "3px 0",
                "&:hover": {
                  borderColor: "none",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "#6ac3db"
                  : state.isFocused
                  ? "#6AC3DB36"
                  : "#fff",
              }),
            }}
            options={options}
            placeholder={placeholder}
            value={value}
            onChange={(val) => onChange(val)}
          />
          {error && <div className="invalid-error">{error.message}</div>}
        </div>
      )}
    />
  );
};

export default CustomSelect;
